import React, { useState } from 'react';
import { Form, Button, Row, Modal, Spinner } from 'react-bootstrap';
import { FaqFormContainer } from './style';
import FormInput from '../../components/common/form/FormInput';
import FormField from '../../components/common/form/FormField';
import axios from 'axios';
import $ from 'jquery';
import toast from 'react-hot-toast';

const influences = [
      {
            title: 'Social Media',
            value: 'Social Media'
      },
      {
            title: 'Friend',
            value: 'Friend'
      },
      {
            title: 'Family',
            value: 'Family'
      },
      {
            title: 'Others',
            value: 'Others'
      }
];

export const feedbacks = [
      {
            title: 'Poor',
            value: 'Poor'
      },
      {
            title: 'Fair',
            value: 'Fair'
      },
      {
            title: 'Good',
            value: 'Good'
      },
      {
            title: 'V. Good',
            value: 'V. Good'
      },
      {
            title: 'Excellent',
            value: 'Excellent'
      }
];

const projectTypes = [
      {
            title: 'Residence',
            value: 'Residence'
      },
      {
            title: 'Commercial',
            value: 'Commercial'
      },
      {
            title: 'Hotel',
            value: 'Hotel'
      },
      {
            title: 'Institutional',
            value: 'Institutional'
      },
      {
            title: 'Hospital',
            value: 'Hospital'
      }
];

export default function FaqForm({ show, setShow }) {
      const [loading, setLoading] = useState(false);

      const [firstName, setFirstName] = useState('');
      const [lastName, setLastName] = useState('');
      const [email, setEmail] = useState('');
      const [phoneNumber, setPhoneNumber] = useState('');
      const [address, setAddress] = useState('');
      const [projectName, setProjectName] = useState('');
      const [occupation, setOccupation] = useState('');
      const [influence, setInfluence] = useState('');
      const [feedback, setFeedback] = useState('');
      const [projectType, setProjectType] = useState('');
      const [productStatus, setProductStatus] = useState('');
      const [serviceStatus, setServiceStatus] = useState('');
      const [agentName, setAgentName] = useState('');

      const handleForm = async (event) => {
            event.preventDefault();
            setLoading(true);

            const data = {
                  first_name: firstName,
                  last_name: lastName,
                  email: email,
                  address: address,
                  phone_number: phoneNumber,
                  project_name: projectName,
                  occupation: occupation,
                  influence: influence,
                  feedback: feedback,
                  project_type: projectType,
                  product_feedback: productStatus,
                  service_feedback: serviceStatus,
                  agent_name: agentName
            };

            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/feedbacks`,
                        data,
                        {
                              headers: {
                                    apikey: process.env.REACT_APP_Api_Key
                              }
                        }
                  )
                  .then((response) => {
                        setTimeout(() => {
                              if (response.data.result === 'success') {
                                    $('form').trigger('reset');
                                    setShow(false);
                                    setFirstName('');
                                    setLastName('');
                                    setEmail('');
                                    setPhoneNumber('');
                                    setAddress('');
                                    setProjectName('');
                                    setOccupation('');
                                    setInfluence('');
                                    setFeedback('');
                                    setProjectType('');
                                    setProductStatus('');
                                    setServiceStatus('');
                                    setAgentName('');
                              }
                              if (response.data.result === 'error') {
                                    if (response.data.message.first_name) {
                                          toast.error(
                                                response.data.message.first_name
                                          );
                                    }
                                    if (response.data.message.last_name) {
                                          toast.error(
                                                response.data.message.last_name
                                          );
                                    }
                                    if (response.data.message.email) {
                                          toast.error(
                                                response.data.message.email
                                          );
                                    }
                                    if (response.data.message.phone_number) {
                                          toast.error(
                                                response.data.message
                                                      .phone_number
                                          );
                                    }
                                    if (response.data.message.address) {
                                          toast.error(
                                                response.data.message.address
                                          );
                                    }
                                    if (response.data.message.project_name) {
                                          toast.error(
                                                response.data.message
                                                      .project_name
                                          );
                                    }
                                    if (response.data.message.occupation) {
                                          toast.error(
                                                response.data.message.occupation
                                          );
                                    }
                                    if (response.data.message.influence) {
                                          toast.error(
                                                response.data.message.influence
                                          );
                                    }
                                    if (response.data.message.feedback) {
                                          toast.error(
                                                response.data.message.feedback
                                          );
                                    }
                                    if (response.data.message.project_type) {
                                          toast.error(
                                                response.data.message
                                                      .project_type
                                          );
                                    }
                                    if (
                                          response.data.message.product_feedback
                                    ) {
                                          toast.error(
                                                response.data.message
                                                      .product_feedback
                                          );
                                    }
                                    if (
                                          response.data.message.service_feedback
                                    ) {
                                          toast.error(
                                                response.data.message
                                                      .service_feedback
                                          );
                                    }
                                    if (response.data.message.agent_name) {
                                          toast.error(
                                                response.data.message.agent_name
                                          );
                                    }
                              }
                              setLoading(false);
                        }, 1000);
                        setTimeout(() => {
                              toast.success(response.data.message);
                        }, 2000);
                  })
                  .catch((error) => {
                        setTimeout(() => {
                              console.log(error.message);
                              setLoading(false);
                        }, 2000);
                  });
      };

      return (
            <>
                  <Modal onHide={() => setShow(!show)} show={show} size="lg">
                        <Modal.Header closeButton>
                              <h3>Contact / Enquiry Form</h3>
                        </Modal.Header>
                        <Modal.Body>
                              <FaqFormContainer
                                    className="mx-auto"
                                    style={{ maxWidth: '700px' }}
                              >
                                    <Form onSubmit={handleForm}>
                                          <Row>
                                                <FormInput
                                                      title="First Name"
                                                      required={true}
                                                      handleChange={
                                                            setFirstName
                                                      }
                                                />
                                                <FormInput
                                                      title="Last Name"
                                                      required={true}
                                                      handleChange={setLastName}
                                                />
                                                <FormInput
                                                      title="Email"
                                                      handleChange={setEmail}
                                                />
                                                <FormInput
                                                      title="Phone No"
                                                      required={true}
                                                      handleChange={
                                                            setPhoneNumber
                                                      }
                                                />
                                                <FormInput
                                                      title="Address"
                                                      required={true}
                                                      handleChange={setAddress}
                                                />
                                                <FormInput
                                                      title="Occupation"
                                                      required={true}
                                                      handleChange={
                                                            setOccupation
                                                      }
                                                />
                                                <FormInput
                                                      title="Project Name"
                                                      classes={12}
                                                      handleChange={
                                                            setProjectName
                                                      }
                                                />
                                                <FormField
                                                      title="Project Type"
                                                      options={projectTypes}
                                                      handleForm={
                                                            setProjectType
                                                      }
                                                      value={projectType}
                                                />
                                                <FormField
                                                      title="How do you hear about us?"
                                                      options={influences}
                                                      handleForm={setInfluence}
                                                      value={influence}
                                                />
                                                <FormField
                                                      title="Display Feedback"
                                                      options={feedbacks}
                                                      handleForm={setFeedback}
                                                      value={feedback}
                                                />
                                                <FormField
                                                      title="Quality of Product"
                                                      options={feedbacks}
                                                      handleForm={
                                                            setProductStatus
                                                      }
                                                      value={productStatus}
                                                />
                                                <FormField
                                                      title="Quality of Service"
                                                      options={feedbacks}
                                                      handleForm={
                                                            setServiceStatus
                                                      }
                                                      value={serviceStatus}
                                                />

                                                {/* <Col lg={12}>
                                                      <fieldset>
                                                            <legend>
                                                                  Inhouse Agent
                                                            </legend>
                                                            <FormSelect
                                                                  name="inhouseagent"
                                                                  required=""
                                                            >
                                                                  <option
                                                                        value=""
                                                                        disabled=""
                                                                        selected=""
                                                                  >
                                                                        Select
                                                                        Agent
                                                                  </option>
                                                                  <option value="Bahrti Giri">
                                                                        Bahrti
                                                                        Giri
                                                                  </option>
                                                                  <option value="Laxmi Shrestha">
                                                                        Laxmi
                                                                        Shrestha
                                                                  </option>
                                                                  <option value="Shovita Bhattrai">
                                                                        Shovita
                                                                        Bhattrai
                                                                  </option>
                                                                  <option value="Bibek Budathoki">
                                                                        Bibek
                                                                        Budathoki
                                                                  </option>
                                                                  <option value="Ayushi Aggrawal">
                                                                        Ayushi
                                                                        Aggrawal
                                                                  </option>
                                                                  <option value="Ashmi Barun">
                                                                        Ashmi
                                                                        Barun
                                                                  </option>
                                                                  <option value="Sujal Shrestha">
                                                                        Sujal
                                                                        Shrestha
                                                                  </option>
                                                                  <option value="Rupa Pudasaini">
                                                                        Rupa
                                                                        Pudasaini
                                                                  </option>
                                                                  <option value="Payal Goyal">
                                                                        Payal
                                                                        Goyal
                                                                  </option>
                                                                  <option value="Sanjeev Goyal">
                                                                        Sanjeev
                                                                        Goyal
                                                                  </option>
                                                                  <option value="Kusma Neupane">
                                                                        Kusma
                                                                        Neupane
                                                                  </option>
                                                                  <option value="Chabahil Branch">
                                                                        Chabahil
                                                                        Branch
                                                                  </option>
                                                                  <option value="Pepsicola Branch">
                                                                        Pepsicola
                                                                        Branch
                                                                  </option>
                                                            </FormSelect>
                                                      </fieldset>
                                                </Col> */}
                                          </Row>

                                          <Button
                                                type="submit"
                                                disabled={loading}
                                                variant="dark"
                                                className="w-100 mt-4 mb-5"
                                          >
                                                {loading ? (
                                                      <Spinner />
                                                ) : (
                                                      'Submit'
                                                )}
                                          </Button>
                                    </Form>
                              </FaqFormContainer>
                        </Modal.Body>
                  </Modal>
            </>
      );
}
